import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../../providers/data.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

  @Input() message: any;
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() notify: EventEmitter<any> = new EventEmitter();

  mode = 'maken';
  form_message: FormGroup;
  now: Date = new Date();

  constructor(private fb: FormBuilder, public dataService: DataService) {
    this.form_message = this.fb.group({
      title: ['', Validators.required],
      body: ['', Validators.required],
      topics: ['', Validators.required],
      ETA: ['', Validators.required]
    });

  }

  ngOnInit() {
    // if a message exists, assume it's being modified and the form should be patched
    if (!!this.message) {
      this.mode = 'aanpassen';
      this.patchForm();
    }
  }

  patchForm() {
    // patch the ETA to a valid JS date, else it will break
    this.form_message.patchValue({
      title: this.message.title,
      body: this.message.body,
      ETA: new Date(this.message.ETA)
    });

    // strip out conditions if there are any, patch them into the form
    // TODO: make this more universal.
    // if (!!this.message.recipients && this.message.recipients.condition) {
    //   const arr = this.message.recipients.condition.split("'");
    //   let conditions = [];
    //   for (let a in arr) {
    //     let piece = arr[a];
    //     if (parseInt(a) % 2 != 0) {
    //       for (let topic of this.dataService.topics) {
    //         // if it exists in the service, push it
    //         if (topic.value.code === parseInt(piece)) {
    //            conditions.push(topic.value);
    //            break;
    //         }
    //       }
    //     }
    //   }

    //   this.form_message.patchValue({
    //     topics: conditions
    //   });
    // }
  }

  submitMessage() {
    let recipients:  { topic?: string, condition?: string };
    let condition: any;
    let resource = 'message';

    const message = {
      ETA: this.form_message.value.ETA.toISOString(),
      title: this.form_message.value.title,
      body: this.form_message.value.body
    };

    recipients =  { topic: 'all' };

    if (!!this.form_message.value.topics && this.form_message.value.topics.length > 1) {
      for (const t of this.form_message.value.topics) {
        if (!!condition) {
          condition += ' || ' + "'" + t.code.toString() + "'" + ' in topics';
        } else {
          condition = "'" + t.code.toString() + "'" + ' in topics';
        }
      }
      recipients = { condition: condition };
    } else {
      // just one topic selected
      recipients = { topic: this.form_message.value.topics[0].code }
    }

    message['recipients'] = recipients;

    if (!!this.message && !!this.message.id) {
      resource += '/' + this.message.id;
      this.putMessage(resource, message);
    } else {
      this.postMessage(message);
    }

  }

  putMessage(resource: string, message: any) {
    this.dataService.put(resource, message).subscribe(
      (mess) => {
        for (const stored_mess_index in this.dataService.messages) {
          if (this.dataService.messages.hasOwnProperty(stored_mess_index)) {
          const stored_mess = this.dataService.messages[stored_mess_index];
            if (stored_mess['id'] === mess['id']) {
              this.dataService.messages[stored_mess_index] = mess;
            }
          }
        }
        this.notify.emit({type: 'success', title: 'Succes!', body: 'Je bericht is succesvol aangepast'});
        this.close.emit(true);
      },
      (err) => {
        this.notify.emit({type: 'error', title: 'Helaas!', body: 'Het lijkt er op dat er iets fout is gegaan.'});
        console.log(err);
      }
    );
  }

  postMessage(message) {
        this.dataService.post('message', message).subscribe(
      (mess) => {
        this.dataService.messages.unshift(mess);
        this.notify.emit({type: 'success', title:'Succes!', body: 'Je bericht is succesvol aangemaakt'});
        this.close.emit(true);
      },
      (err) => {
        this.notify.emit({type: 'error', title:'Helaas!', body: 'Het lijkt er op dat er iets fout is gegaan.'});
        console.log(err);
      }
    )
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/components/message/message.component.ts